/**
 * @description Сохранить фильтры "Пациенты" (PatientList.vue)
 * @type {string}
 */
export const STORE_PATIENT_FILTERS = 'STORE_PATIENT_FILTERS';

/**
 * @description Очистить фильтры "Пациенты" (PatientList.vue)
 * @type {string}
 */
export const CLEAR_PATIENT_FILTERS = 'CLEAR_PATIENT_FILTERS';
